import styled from "styled-components";
import theme from '../../../theme';
import background from "../../../assets/images/heroMoblie.svg";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: row;
  //overflow-y: hidden;
  @media screen and (max-width: 820px) {
    height: 100%;
  }
`;
export const FormContainer = styled.div`
  width: 50%;
  margin: 0 auto;
  padding: 20px 80px;
  background-color: #fff;
  .error {
    color: red;
    text-align: left;
    font-size: 14px;
    padding: 0px;
    margin-top: -10px;
  }
  @media screen and (max-width: 820px) {
    padding: 30px;
  }

  h1 {
    margin: 30px 0 30px 0;
    font-size: 28px;
    line-height: 38px;
    color: #2b2f38;
  }
  p {
    margin-top: 20px;
    text-align: center;
    color: #667085;
  }
  a {
    text-decoration: none;
    color: ${theme.color.brandDark};
  }
  form {
    label {
      font-size: 14px;
      line-height: 20px;
      padding: 0 5px;
      color: #383e49;
    }

    input {
      width: 100%;
      height: 43px;
      margin-top: 10px;
      border: solid 1px #e0e2e6;
      border-radius: 10px;
      padding: 12px 14px;
      transition: all 0.3s ease;

      &:focus {
        outline: #027f7f;
        border: 1px solid ${theme.color.brandDark};
        background: transparent;
      }
    }
    .eye {
      position: relative;
      left: 95%;
      bottom: 30px;
      cursor: pointer;
    }
    .single-form {
      margin-bottom: 20px;
      input {
        width: 100%;
      }
    }
    button {
      margin-top: 10px;
      height: 43px;
      background-color: ${theme.color.brandDark};
      color: #fff;
      width: 100%;
      border: 1px solid #027f7f;
      border-radius: 10px;
      padding: 12px 20px;
      cursor: pointer;
    }
  }
  @media screen and (max-width: 820px) {
    width: 100%;
    background-color: #fff;
  }
`;
export const FormGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 820px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const ImgSection = styled.div`
  width: 50%;
  background: url(${background}) no-repeat;
  background-size: cover;
  height: 100vh;
  //overflow-y: hidden;
  padding: 550px 30px 30px 30px;

  div {
    width: 100%;
    min-height: 172px;
    padding: 32px;
    border-radius: 8px;
    opacity: 0px;
    background-color: ${theme.color.accent};
    p {
      margin-top: 15px;
      font-size: 20px;
      line-height: 28px;
      color: ${theme.color.brandDeep};
    }
  }

  @media screen and (max-width: 820px) {
    display: none;
  }
`;
